import {
  CLEAR_ERRORS,
  CLEAR_STATE,
  USER_GOAL_UPDATE_REQUEST,
  USER_GOAL_UPDATE_SUCCESS,
  CLEAR_UPDATE_STATE,
  USER_GOAL_UPDATE_FAIL,
} from "../constants/userConstant";

export const updateGoalReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_GOAL_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_GOAL_UPDATE_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };
    case USER_GOAL_UPDATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case CLEAR_UPDATE_STATE:
      return {
        loading: false,
        userInfo: null,
      };

    default:
      return state;
  }
};